
import React from 'react';
import { Label } from '@/components/ui/label';
import { Slider } from '@/components/ui/slider';

interface AvatarCropSliderProps {
  cropScale: number;
  setCropScale: (scale: number) => void;
  isProcessing: boolean;
}

const AvatarCropSlider: React.FC<AvatarCropSliderProps> = ({
  cropScale,
  setCropScale,
  isProcessing
}) => {
  return (
    <div className="space-y-2">
      <Label className="text-xs text-muted-foreground">Adjust zoom</Label>
      <Slider
        value={[cropScale]}
        min={1}
        max={2}
        step={0.05}
        onValueChange={(values) => setCropScale(values[0])}
        disabled={isProcessing}
        className="w-full"
      />
    </div>
  );
};

export default AvatarCropSlider;
